export default __webpack_public_path__ + "static/media/Class_3_Mobile.01706728.jpg";